const MOBILE_ICON_BUTTON_SIZE = 40;
const HEADER_HEIGHT_XS = 56;
const HEADER_HEIGHT_MD = 64;
const HEADER_HEIGHT_CSS_VARIABLE = '--redesign-header-height';

export {
    MOBILE_ICON_BUTTON_SIZE, HEADER_HEIGHT_XS, HEADER_HEIGHT_MD, HEADER_HEIGHT_CSS_VARIABLE,
};
